<script lang="ts" module>
  /** 24×24 stroke icons, drawn for this app. */
  const PATHS = {
    walk: 'M4 12h13M13 7l5 5-5 5',
    upgrades: 'M12 19V6M6.5 11.5 12 6l5.5 5.5M5 21h14',
    medal: 'M8 3h8l-2 6h-4zM12 21a6 6 0 1 0 0-12 6 6 0 0 0 0 12zM12 12.5v5M10 14.5l2-2',
    records: 'M5 20V10M12 20V4M19 20v-7',
    settings: 'M4 7h10M18 7h2M4 17h4M12 17h8M16 5v4M10 15v4',
    flip: 'M7 4 3 8l4 4M3 8h13a4 4 0 0 1 0 8h-2M17 20l4-4-4-4M21 16H8',
    timer: 'M12 21a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM12 9v4l2.5 2.5M10 2h4',
    close: 'M6 6l12 12M18 6 6 18',
    check: 'M5 12.5 10 17l9-10',
    lock: 'M6 11h12v9H6zM9 11V8a3 3 0 0 1 6 0v3',
    left: 'M15 5l-7 7 7 7',
    right: 'M9 5l7 7-7 7',
    target: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8z',
    copy: 'M9 9h11v11H9zM5 15H4V4h11v1',
    sound: 'M4 10h3l5-4v12l-5-4H4zM16 9a4 4 0 0 1 0 6M18.5 6.5a7.5 7.5 0 0 1 0 11',
    mute: 'M4 10h3l5-4v12l-5-4H4zM16 10l4 4M20 10l-4 4',
  } as const;
  export type IconName = keyof typeof PATHS;
</script>

<script lang="ts">
  let { name, size = 20 }: { name: IconName; size?: number } = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="1.8"
  stroke-linecap="round"
  stroke-linejoin="round"
  aria-hidden="true"
>
  <path d={PATHS[name]} />
</svg>
